import React from "react";
import { Modal, Button } from "antd";
import styled from "styled-components";
import Iconmoon from "../../Components/IconsFiles/icon";
import RestoreVersion from "./versions-list";

const StyledModal = styled(Modal)`
  .ant-modal-content {
    width: ${({ width }) => width || "301px"};
    // height: 310px;
    // left: calc(50% - 301px / 2 - 0.5px);
    top: calc(50% - 310px / 2);
    background: #ffffff;
    border-radius: 8px;
    margin-top: 124px;
    padding-bottom: 16px !important;
  }
  .ant-modal-footer-section {
    text-align: center !important;
    display: flex;
    flex-direction: row;
    align-content: center;
    justify-content: space-around;
    align-items: center;
  }
  .ant-modal-footer {
    display: none;
  }
  .Popup-img {
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    margin-bottom: 11px;
  }
  .Popup-content {
    span {
      font-family: var(--sf-pro-display-m);
      font-style: normal;
      font-size: 20px;
      line-height: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      align-content: center;
      margin-bottom: 3px;
      text-align: center;
    }
    p {
      font-family: var(--sf-pro-text);
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      text-align: center;
      padding: 12px;
      color: #605e5c;
    }
  }
  .themeBtn {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: var(--theme-color);
    text-align: center;
    border: none !important;
    outline: none !important;
    margin: 0px 12px;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ffffff;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: var(--theme-color-hover);
    }
  }
  .themeBtn-plane {
    min-width: 103px;
    border-radius: 8px;
    padding: 4px 4px;
    min-height: 36px;
    background-color: #ffff;
    text-align: center;
    outline: none !important;
    margin: 0px 12px;
    border: 1px solid #ea655b;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      position: relative;
      top: 2px;
    }
    span {
      font-size: 14px;
      font-family: var(--sf-pro-display);
      color: #ea655b;
      line-height: 16px;
      text-align: center;
      margin-left: 10px;
      position: relative;
      top: -1px;
    }
    &:hover {
      background-color: #fff;
      border: 1px solid var(--theme-color-hover);
    }
  }
  .ant-modal-close {
    display: block !important;
  }

  .ant-modal-close-x {
    display: flex !important;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #000;
  }

  .themeBtn svg {
    position: relative;
    top: 2px;
    border: 0px solid #fff;
    padding: 2px;
    border-radius: 4px;
  }
  .themeBtn-plane {
    .plusPopUpBorder {
      position: relative;
      // top: 2px;
      border: 1px solid var(--theme-color);
      padding: 2px;
      border-radius: 4px;
      width: 13px;
      height: 13px;
      svg {
        transform: rotate(133deg);
        top: -8px;
        right: 1px;
      }
    }
  }
  .top-close-icon {
    display: flex;
    justify-content: flex-end;
    cursor: pointer;
  }
`;

const DeleteConfirmationModal = ({
  visible,
  cancelAction,
  confirmAction,
  heading,
  action,
  onConfirmClick,
  text,
  publish_version,
}) => {
  return (
    <StyledModal
      visible={visible}
      onCancel={cancelAction}
      footer={null}
      centered
      closable={true}
      width={400}
      maskClosable={false}
    >
      <h2
        style={{
          marginBottom: 12,
          marginTop: "-13px",
          marginRight: "10px",
          paddingLeft: "1px",
        }}
      >
        {action === "restore" ? "Restore version?" : heading}
      </h2>
      <p style={{ marginBottom: 0, color: "#888" }}>
        {action == "restore"
          ? "Are you sure you want to restore the selected versoin"
          : action === "delete"
          ? "Are you sure you want to delete?"
          : ""}
      </p>
      {action === "delete" && (
        <p style={{ marginTop: 0, color: "#888" }}>
          This action cannot be undone
        </p>
      )}
      {action === "restore" ? (
        <RestoreVersion onConfirmClick={onConfirmClick} publish_version={publish_version} />
      ) : (
        <p style={{ marginTop: 0, color: "#888" }}>{text}</p>
      )}

     {action === "restore"?<></>: <div
        style={{
          marginTop: 24,
          display: "flex",
          justifyContent: "space-between",
          columnGap: 0,
          marginBottom: "-12px",
        }}
      >
        <Button
          key="back"
          style={{ marginRight: "-1px" }}
          className="themeBtn-plane"
          onClick={cancelAction}
        >
          <div className="plusPopUpBorder">
            <Iconmoon
              icon="plus-sign"
              size={9}
              color="#EA655B"
              className="ant-ico-sec"
            />
          </div>
          Cancel
        </Button>

        {/* Delete button */}
        <Button className="themeBtn" onClick={confirmAction}>
          {action == "delete" && (
            <Iconmoon icon="delete" size={18} color="#FFF" />
          )}
          {action == "restore" && (
            <Iconmoon icon="restore" size={18} color="#FFF" />
          )}
          {action == "add" && (
            <Iconmoon icon="plus-sign" size={18} color="#FFF" />
          )}
          <span>
            {action == "restore"
              ? "Restore"
              : action == "delete"
              ? "Delete"
              : "Add"}
          </span>
        </Button>
      </div>}
    </StyledModal>
  );
};

export default DeleteConfirmationModal;
